import React, { FC, useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ArrowDateFilter from 'components/shared/arrow-date-filter/arrow-date-filter.component';

type TransportPlannerPageActionsProps = {
    onDateChange: (newDate: Date) => void;
    onFilterTextChange: (newFilterText: string) => void;
};
const TransportPlannerPageActions: FC<TransportPlannerPageActionsProps> = ({
    onDateChange,
    onFilterTextChange,
}: TransportPlannerPageActionsProps) => {
    const { t: translate } = useTranslation(['transport']);
    const search = useLocation().search;
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());

    const handleDateChange = (date: Date) => {
        setSelectedDate(date);
        onDateChange(date);
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(search);
        const date = queryParams.get('date');
        if (date) {
            const urlDate = new Date(parseInt(date));
            setSelectedDate(urlDate);
            onDateChange(urlDate);
        }
    }, []);

    return (
        <Box display="flex" alignItems="center">
            <ArrowDateFilter
                dateValue={selectedDate}
                onDateFilterChange={(newDate: Date | null) => handleDateChange(newDate || new Date())}
                label=""
            />
            <Box ml={2} width={300}>
                <TextField
                    margin="dense"
                    fullWidth
                    onChange={(event) => onFilterTextChange(event.target.value)}
                    label={translate('transport:FILTER_ON_CLINIC')}
                />
            </Box>
        </Box>
    );
};

export default TransportPlannerPageActions;
